/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import PreviousIcon from "dc-icons/viewer2021/SDC_SkipLeft_18_N.svg";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import { isPrevButtonDisabled } from "selectors/readAloudSelectors";
import ReadAloudCss from "components/readAloud/readAloud.css";

const mapStoreToProps = stores => ({
  icon: PreviousIcon,
  className: ReadAloudCss.controls,
  shouldDisable: isPrevButtonDisabled(stores),
  clickHandler: () => stores.readAloudStore.prev(),
  ariaLabel: "arialabel.readAloudPrev",
  tooltipString: "tooltip.readAloudPrev"
});

const ReadAloudPrevContainer = inject(mapStoreToProps)(ButtonWrapper);
export { ReadAloudPrevContainer };
